import { location } from '~src/util';

export const useLocation = () => {
  const parameters = new URLSearchParams(location.search);

  const clearParameters = () => {
    location.href = location.href.split('?')[0];
  };

  return {
    location,
    parameters,
    clearParameters,
  };
};
